<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewAbsenteeism"
            :searchFilters="searchFilters"
            @searchPage="searchAbsenteeism"
            @resetFilters="resetFilters"
            @removeItem="removeAbsenteeism"
            @removeSelectedItems="removeAbsenteeisms"
            @printList="printabsentList"
            @printExcel="downloadDeductionsExcel"
            @printCSV="downloadDeductionsCSV"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="absentList"
            :actions="actions"
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveAbsenteeism" @handleReset="handleReset"
            />
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import PrintJS from 'print-js';

export default{
    name: 'Absenteeism',
    components:{
        PageComponent, MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const loader = ref('none');
        const modal_loader = ref('none');
        const ledComponentKey = ref(0);
        const idField = 'absenteeism_id';
        const addButtonLabel = ref('New Absenteeism');
        const addingRight = ref('Adding Absenteeism');
        const removingRight = ref('Deleting Absenteeism');
        const rightsModule = ref('HR');
        const title = ref('Absenteeism Details');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const absentList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_left = ref('500px');
        const modal_width = ref('40vw');
        const ledgerID = ref('');
        const isEditing = computed(()=> store.state.Absenteeism.isEditing);
        const selectedAbsent = computed(()=> store.state.Absenteeism.selectedAbsent);
        const selectedLedger = computed(()=> store.state.Absenteeism.selectedLedger);
        const ledgerArray = computed(() => store.state.Ledgers.ledgerArr);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Name", key:"name"},
            {label: "Date", key:"date"},
            {label: "Type", key: "charge_type"},
            {label: "Taxed", key:"taxation_status"},
            {label: "Charge Mode", key:"charge_mode"},
            {label: "Posting Account", key:"posting_account_name"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Absenteeism', rightName: 'Editing Absenteeism'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Absenteeism', rightName: 'Deleting Absenteeism'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const name_search = ref('');;
        const searchFilters = ref([
            {type:'text', placeholder:"Name...", value: name_search, width:56,},
        ]);
        const fetchLedgers = async() =>{
            await store.dispatch('Ledgers/fetchLedgers', {company:companyID.value})
        };
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const handleSelectedLedger = async(option) =>{
            await store.dispatch('Ledgers/handleSelectedLedger', option)
            ledgerID.value = store.state.Ledgers.ledgerID;
        };
        const clearSelectedLedger = async() =>{
            await store.dispatch('Ledgers/updateState', {ledgerID: ''});
            ledgerID.value = store.state.Ledgers.ledgerID;
        }
        const formFields = ref([]);
        const ledgerValue = computed(() => {
           return (selectedAbsent.value && selectedAbsent.value.posting_account && !ledgerID.value) ? selectedAbsent.value.posting_account.ledger_id : ledgerID.value;

        });
        const updateFormFields = () => {
            formFields.value = [
                
                { type: 'text', name: 'name',label: "Name", value: selectedAbsent.value?.name, required: true },
                { type: 'date', name: 'date',label: "Effective Date", value: selectedAbsent.value?.date, required: true },
                { type: 'dropdown', name: 'charge_mode',label: "Charge Mode", value: selectedAbsent.value?.charge_mode || 'Salary', placeholder: "", required: true, options: [{ text: 'Leave', value: 'Leave' }, { text: 'Salary', value: 'Salary' }] },
                { type: 'dropdown', name: 'charge_type',label: "Charge Type", value: selectedAbsent.value?.charge_type || 'Days', placeholder: "", required: true, options: [{ text: 'Hours', value: 'Hours' }, { text: 'Days', value: 'Days' }] },
                { type: 'dropdown', name: 'taxation_status',label: "Taxed", value: selectedAbsent.value?.taxation_status || 'No', placeholder: "", required: true, options: [{ text: 'Yes', value: 'Yes' }, { text: 'No', value: 'No' }] },    
                {required: false},
                {  
                    type:'search-dropdown', label:"Posting Account", value: ledgerValue.value, componentKey: ledComponentKey,
                    selectOptions: ledgerArray, optionSelected: handleSelectedLedger, required: true,
                    searchPlaceholder: 'Select Posting Account...', dropdownWidth: '500px', updateValue: selectedLedger.value,
                    clearSearch: clearSelectedLedger
                },
            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            ledComponentKey.value += 1;
            ledgerID.value = '';
        }

        watch([selectedAbsent, selectedLedger], () => {
            if (selectedAbsent.value && selectedLedger.value) {
                ledComponentKey.value += 1;
                updateFormFields();
            }
            
        }, { immediate: true });
        
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createAbsenteeism = async() =>{
            showModalLoader();
            let formData = {
                name: formFields.value[0].value,
                date: formFields.value[1].value,
                charge_mode: formFields.value[2].value,
                charge_type: formFields.value[3].value,
                taxation_status: formFields.value[4].value || 'No',
                posting_account: ledgerID.value,
                posting_account_id: ledgerID.value,
                company: companyID.value
            }
  
            errors.value = [];
            for(let i=1; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
            if(ledgerValue.value == ''){
                errors.value.push('error')
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Absenteeism/createAbsenteeism', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Absenteeism created successfully!');
                        handleReset();
                        ledComponentKey.value += 1;
                    } else {
                        toast.error('An error occurred while creating the Absenteeism.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Absenteeism: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchAbsenteeism();
                }
            }
        }
        const updateAbsenteeism = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                absenteeism: selectedAbsent.value.absenteeism_id,
                name: formFields.value[0].value,
                date: formFields.value[1].value,
                charge_mode: formFields.value[2].value,
                charge_type: formFields.value[3].value,
                taxation_status: formFields.value[4].value || 'No',
                posting_account: ledgerValue.value,
                posting_account_id: ledgerValue.value,
                company: companyID.value
            }

            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type != 'search-dropdown'  && formFields.value[i].required == true){
                    errors.value.push('Error');
                }
            }
            if(ledgerValue.value == ''){
                errors.value.push('error')
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Absenteeism/updateAbsenteeism', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        ledComponentKey.value += 1;
                        toast.success("Absenteeism updated successfully!");              
                    } else {
                        toast.error('An error occurred while updating the Absenteeism.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Absenteeism: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    store.dispatch("Absenteeism/updateState",{selectedAbsent:null})
                    searchAbsenteeism();
                }             
            }
        }
        const saveAbsenteeism = () =>{
            if(isEditing.value == true){
                updateAbsenteeism();
            }else{
                createAbsenteeism();
            }
        }
        const removeAbsenteeism = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    absenteeism: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Absenteeism/deleteAbsenteeism',formData)
                    if(response && response.status == 200){
                        toast.success("Absenteeism Removed Succesfully");
                        searchAbsenteeism();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Absenteeism: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Absenteeism") 
            }else{
                toast.error("Please Select An Absenteeism To Remove")
            }
        }
        const removeAbsenteeisms = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    absenteeism: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Absenteeism/deleteAbsenteeism',formData)
                    if(response && response.status == 200){
                        toast.success("Absenteeism(s) Removed Succesfully");
                        searchAbsenteeism();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Absenteeism: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select An Absenteeism To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchAbsenteeism = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                name: name_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/absenteeisms-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                absentList.value = response.data.results;
                store.commit('Absenteeism/LIST_ABSENTEEISMS', absentList.value)
                propResults.value = response.data;
                propArrLen.value = absentList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchAbsenteeism(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            name_search.value = "";
            searchAbsenteeism();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchAbsenteeism();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchAbsenteeism();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchAbsenteeism();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchAbsenteeism();
            // scrollToTop();
        }
        const addNewAbsenteeism = () =>{
            store.dispatch("Absenteeism/updateState",{selectedAbsent:null, selectedLedger:null});
            ledComponentKey.value += 1;
            handleReset();
            updateFormFields();
            propModalVisible.value = true;
            store.dispatch("Absenteeism/updateState",{isEditing:false})
            flex_basis.value = '1/3';
            flex_basis_percentage.value = '33.33';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const absentID = row['absenteeism_id'];
                let formData = {
                    company: companyID.value,
                    absenteeism: absentID
                }
                await store.dispatch('Absenteeism/fetchAbsenteeism',formData)
                propModalVisible.value = true;
                flex_basis.value = '1/3';
                flex_basis_percentage.value = '33.33';

            }else if(action == 'delete'){
                const absentID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    absenteeism: absentID
                }
                await store.dispatch('Absenteeism/deleteAbsenteeism',formData).
                then(()=>{
                    searchAbsenteeism();
                })
            }else if(action == 'view'){
                
            }
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        };
        const printabsentList = () =>{
            showLoader();
            let formData = {
                deduction_name: name_search.value,
                deduction_type: deduction_type_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            } 

            axios
            .post("api/v1/export-deductions-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const blob1 = new Blob([response.data]);
                        // Convert blob to URL
                        const url = URL.createObjectURL(blob1);
                        PrintJS({printable: url, type: 'pdf'});
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const downloadDeductionsExcel = () =>{
            showLoader();
            let formData = {
                deduction_name: name_search.value,
                deduction_type: deduction_type_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios.post("api/v1/export-deductions-excel/", formData, { responseType: 'blob' })
            .then((response)=>{
                if(response.status == 200){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Overtimes.xlsx');
                document.body.appendChild(link);
                link.click();
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const downloadDeductionsCSV = () =>{
            showLoader();
            let formData = {
                deduction_name: name_search.value,
                deduction_type: deduction_type_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios.post("api/v1/export-deductions-csv/", formData, { responseType: 'blob' })
            .then((response)=>{
                if(response.status == 200){
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Deductions.csv');
                document.body.appendChild(link);
                link.click();
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        onBeforeMount(()=>{
            searchAbsenteeism();
            fetchLedgers();
        })
        return{
            title, searchAbsenteeism,resetFilters, addButtonLabel, searchFilters, tableColumns, absentList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewAbsenteeism, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveAbsenteeism, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            removeAbsenteeism, removeAbsenteeisms,addingRight,removingRight,rightsModule,printabsentList,selectSearchQuantity,selectedValue,
            downloadDeductionsCSV,downloadDeductionsExcel
        }
    }
};
</script>